import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ActionMenuItem, ExternalLinkMenuItem, MenuItem, ParentMenuItem, RouterLinkMenuItem } from '../models';
import { OneGoMenuTitleIconComponent } from './onego-menu-title-icon.component';

@Component({
    selector: 'onego-menu-item',
    imports: [RouterModule, FontAwesomeModule, OneGoMenuTitleIconComponent],
    templateUrl: './onego-menu-item.component.html',
    styleUrls: ['./onego-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneGoMenuItemComponent {
    public readonly item = input.required<MenuItem>();
    public readonly index = input.required<number>();

    protected readonly helper = OneGoMenuItemComponent;

    public readonly toggleNavbar =
        input.required<(event: MouseEvent | TouchEvent, index: number, open?: boolean | undefined) => void>();

    public static isRouterLinkItem(item: MenuItem): item is RouterLinkMenuItem {
        return Array.isArray((item as RouterLinkMenuItem).link);
    }

    public static isExternalLinkItem(item: MenuItem): item is RouterLinkMenuItem {
        const i = item as ExternalLinkMenuItem;
        return typeof i.link === 'string' && i.external === true;
    }

    public static isParentItem(item: MenuItem): item is ParentMenuItem {
        return (item as ParentMenuItem).subItems !== undefined;
    }

    public static isActionItem(item: MenuItem): item is ActionMenuItem {
        return (item as ActionMenuItem).action !== undefined;
    }
}
